import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=4dbae045&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"
import style0 from "./Warehouses.vue?vue&type=style&index=0&id=4dbae045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbae045",
  null
  
)

export default component.exports